export const ART_CATEGORIES = [
  'Musician',
  'Illustrations & Painting',
  'Writing and Poetry',
  'Comedy',
  'Photography/Videography',
  'Software and Coding',
];

export const MUSICIAN_SUBCATEGORIES = ['Guitar', 'Vocals', 'Bass', 'Drums', 'Keyboard', 'Production', 'Other'];

export const PROFESSIONS = [
  'Artist', '3D Designer', 'Animator', 'Illustrator', 'Painter', 'Sculptor', 'Graphic Designer',
  'UI/UX Designer', 'Fashion Designer', 'Interior Designer', 'Architect', 'Photographer', 'Videographer',
  'Filmmaker', 'Video Editor', 'Musician', 'Guitarist', 'Singer', 'Bassist', 'Drummer', 'Keyboardist',
  'Music Producer', 'DJ', 'Composer', 'Songwriter', 'Dancer', 'Actor', 'Theatre Artist', 'Comedian',
  'Writer', 'Poet', 'Author', 'Journalist', 'Editor', 'Translator', 'Content Creator',
  'Coder', 'App Developer', 'Web Developer', 'Software Engineer', 'Game Developer', 'Data Scientist',
  'AI/ML Engineer', 'Cybersecurity Specialist', 'IT Professional', 'Product Manager', 'Project Manager',
  'Engineer', 'Civil Engineer', 'Mechanical Engineer', 'Electrical Engineer', 'Researcher', 'Scientist',
  'Doctor', 'Nurse', 'Dentist', 'Pharmacist', 'Physiotherapist', 'Psychologist', 'Therapist', 'Veterinarian',
  'Teacher', 'Professor', 'Tutor', 'Student', 'Coach', 'Fitness Trainer', 'Yoga Instructor', 'Nutritionist',
  'Digital Marketing', 'SEO Specialist', 'Social Media Manager', 'Copywriter', 'Public Relations',
  'Sales Professional', 'Entrepreneur', 'Business Owner', 'Consultant', 'Accountant', 'Financial Analyst',
  'Banker', 'Lawyer', 'Human Resources', 'Recruiter', 'Real Estate Professional', 'Civil Servant',
  'Social Worker', 'Community Organizer', 'Volunteer', 'Chef', 'Baker', 'Hospitality Professional',
  'Event Planner', 'Travel Guide', 'Athlete', 'Farmer', 'Gardener', 'Carpenter', 'Electrician', 'Plumber',
  'Mechanic', 'Craftsperson', 'Retail Professional', 'Delivery Professional', 'Driver', 'Homemaker',
  'Caregiver', 'Retired', 'Other',
  ...ART_CATEGORIES.filter((category) => category !== 'Musician'),
];

const LEGACY_MUSIC_SKILLS = {
  Guitar: 'Guitarist', Vocals: 'Singer', Bass: 'Bassist', Drums: 'Drummer',
  Keyboard: 'Keyboardist', Production: 'Music Producer', Other: 'Other',
};

export function profileProfessions(profile = {}) {
  const categories = Array.isArray(profile?.professions)
    ? profile.professions
    : Array.isArray(profile?.artCategories) ? profile.artCategories : [];
  const specialties = !Array.isArray(profile?.professions) && categories.includes('Musician') && Array.isArray(profile?.musicianSubcategories)
    ? profile.musicianSubcategories.map((skill) => LEGACY_MUSIC_SKILLS[skill]).filter(Boolean) : [];
  return [...new Set([...categories, ...specialties])].filter((category) => PROFESSIONS.includes(category));
}

export function matchesProfessions(profile, selected) {
  if (!selected.length) return true;
  const professions = profileProfessions(profile);
  return selected.some((profession) => professions.includes(profession));
}

export function artistFields(profile = {}) {
  const categories = profileProfessions(profile);
  const specialties = Array.isArray(profile?.musicianSubcategories) ? profile.musicianSubcategories : [];
  return {
    artCategories: categories,
    musicianSubcategories: categories.includes('Musician')
      ? MUSICIAN_SUBCATEGORIES.filter((category) => specialties.includes(category))
      : [],
  };
}

export function validateArtistFields(artCategories, musicianSubcategories) {
  if (!Array.isArray(artCategories) || !artCategories.length) return 'Choose at least one profession or skill.';
  if (artCategories.some((category) => !PROFESSIONS.includes(category))) return 'Choose from the available professions and skills.';
  if (!Array.isArray(musicianSubcategories) || musicianSubcategories.some((category) => !MUSICIAN_SUBCATEGORIES.includes(category))) return 'Choose from the available musician subcategories.';
  return '';
}

export function hasArtistProfile(profile) {
  return Boolean(profile?.username && profileProfessions(profile).length);
}

export function artistSearchText(profile) {
  const { artCategories, musicianSubcategories } = artistFields(profile);
  return [profile.username, profile.displayName, profile.bio, profile.locationLabel, profile.area, profile.city, profile.country, ...artCategories, ...musicianSubcategories].filter(Boolean).join(' ').toLowerCase();
}

export function safeWorkUrl(value) {
  if (!value?.trim()) return '';
  try {
    const url = new URL(value.trim());
    return ['https:', 'http:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
}
